import View from '@play-co/timestep-core/lib/ui/View';
import { Feature } from 'src/replicant/analytics';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { HudMeter, type HudMeterOpts } from 'src/game/components/HudMeter';
import uiConfig from 'src/lib/ui/config';
import i18n from 'src/lib/i18n/i18n';
import StateObserver from 'src/StateObserver';
const buttonWidth = 573;
const buttonHeight = 114;

// Heart-only height — clips the label area that starts at y:106
const meterHeartHeight = 105;
const meterScale = 0.7;
const meterVisualHeight = meterHeartHeight * meterScale;

const meterConfig: HudMeterOpts = {
  ...uiConfig.hud.loveMeter,
  label: uiConfig.hud.meterLabel,
  text: uiConfig.hud.meterText,
};
meterConfig.view = { ...meterConfig.view, x: 0, y: 0 };

export default class JankenCareButton extends View {
  private meter: HudMeter;

  constructor(opts: { onClick: () => void }) {
    super({
      width: buttonWidth,
      height: buttonHeight,
    });

    // Button fills the entire view
    const button = this.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        x: buttonWidth / 2,
        y: buttonHeight / 2,
        width: buttonWidth,
        height: buttonHeight,
        centerOnOrigin: true,
        labelOffsetX: 30,
        labelOffsetY: -1,
        fontSize: StateObserver.getLocale() === 'ja' ? 43 : 52,
        font: 'Body',
        localeText: () => i18n('janken.carePrompt'),
        onClick: async () => opts.onClick(),
        tracking: {
          feature: Feature.JANKEN._,
          $subFeature: Feature.JANKEN.POPUP_CARE,
        },
      }),
    );

    // Love meter scaled to fit inside button, clipped to heart only (no label)
    // Added as button subview so it animates with the press-down state
    this.meter = button.addSubview(new HudMeter(meterConfig));
    this.meter.updateOpts({
      clip: true,
      height: meterHeartHeight,
      scale: meterScale,
      x: 15,
      y: (buttonHeight - meterVisualHeight) / 2,
      canHandleEvents: false,
    });
  }

  public setLoveValue(value: number) {
    this.meter.setMeterValue(value);
  }
}
